import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  EmployeePermission,
  EmployeePermissionsFull,
  readEmployeePermissions,
  updateEmployeePermissions,
} from 'src/api/permissions';
import { defaultServerError } from 'src/utils/consts';

import { messagesActions } from '../messages/slice';
import { StoreState, ThunkConfig } from '../types';
import { getEmployeeNumber } from '../user/selectors';
import { fetchUserPermissions } from '../user/services';

import { getPermissionsState } from './selectors';

export const fetchEmployeePermissions = createAsyncThunk<
  EmployeePermissionsFull,
  string,
  ThunkConfig<string>
>('permissions/fetchEmployeePermissions', async (id, { rejectWithValue }) => {
  try {
    const response = await readEmployeePermissions(id);

    return response;
  } catch (e) {
    return rejectWithValue((e as AxiosError).message);
  }
});

export const saveEmployeePermissions = createAsyncThunk<
  void,
  void,
  ThunkConfig<string>
>(
  'permissions/saveEmployeePermissions',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState() as StoreState;
      const { employee, permissions } = getPermissionsState(state);
      const employeeNumber = getEmployeeNumber(state);
      if (!employee?.id) return;

      const nextPermissions: EmployeePermission[] = [];
      for (const permission of permissions) {
        if (permission.enabled) nextPermissions.push(permission.permissionId);
      }

      await updateEmployeePermissions({
        employeeNumber: employee.id as string,
        permissions: nextPermissions,
      });

      if (employee.id === employeeNumber) dispatch(fetchUserPermissions());
    } catch (e) {
      dispatch(messagesActions.show({ message: defaultServerError }));
      return rejectWithValue((e as AxiosError).message);
    }
  },
);
